import Vue from 'vue'
import {mapGetters} from 'vuex'
import PrePurchaseFaresService from 'js/services/api/ticketing/pre-purchase-fares'
import WstrackAmiService from 'js/services/api/ticketing/wstrack-ami'

import FixedPriceFares from './_fixed-price-fares'
import OriginDestinationFares from './_origin-destination-fares'
import DownloadableFares from './_downloadable-fares'

import template from './index.pug'

const FIXED_PRICE_TYPE = 'fixed_price'
const ORIGIN_DESTINATION_TYPE = 'origin_destination_price'
const DOWNLOADABLE_TYPE = 'downloadable'

const ICON_CLASSES = {
  [FIXED_PRICE_TYPE]: 'tag text-gray3',
  [DOWNLOADABLE_TYPE]: 'download-file text-gray3',
  [ORIGIN_DESTINATION_TYPE]: 'map-marker text-gray3'
}

export default Vue.extend({
  name: 'prepay-page',
  template: template(),
  components: {FixedPriceFares, OriginDestinationFares, DownloadableFares},

  data() {
    return {
      FIXED_PRICE_TYPE,
      ORIGIN_DESTINATION_TYPE,
      DOWNLOADABLE_TYPE,
      fares: [],
      selectedSectionId: undefined,
      wstrackEnabled: false,
      deltaTabIndex: 150,
    }
  },

  computed: {
    showDownloadableFares() {
      return this.currentMunicipality.show_downloadable_fares
    },

    faresPriceTypes() {
      return [
        {
          type: ORIGIN_DESTINATION_TYPE,
          hiddenCallback: type => (this.filteredFares(type).length === 0 && !this.wstrackEnabled)
        },
        {
          type: FIXED_PRICE_TYPE,
          hiddenCallback: type => (this.filteredFares(type).length === 0)
        },
        {
          type: DOWNLOADABLE_TYPE,
          hiddenCallback: _type => (!this.showDownloadableFares)
        }
      ]
    },

    //prePurchaseFares es un objeto que recoge todos los textos sobre tarifas
    faresSections() {
      return this.faresPriceTypes.map((fareType, index) => ({
        icon: this.getIcon(fareType.type),
        id: `fare-section-${fareType.type}`,
        label: this.$t(`prePurchaseFares.sections.${fareType.type}.title`),
        title: this.$t(`prePurchaseFares.sections.${fareType.type}.title`),
        description: this.$t(`prePurchaseFares.sections.${fareType.type}.description`),
        value: fareType.type,
        active: this.selectedSectionId === fareType.type,
        hidden: fareType.hiddenCallback(fareType.type),
        alt:this.$t(`prePurchaseFares.sections.${fareType.type}.title`),
        tabindex: this.deltaTabIndex + index,
      }))
    },

    visibleSections() {
      return this.faresSections.filter(section => !section.hidden)
    },

    typesOptions() {
      return this.visibleSections.map(section => ({
        label: this.$t(`prePurchaseFares.sections.${section.value}.title`),
        value: section.value
      }))
    },

    selectedSection() {
      if (this.selectedSectionId) {
        return this.faresSections.find(section => section.value === this.selectedSectionId)
      }
      return undefined
    },

    selectedFares() {
      return this.fares.filter(fare => fare.origin_destination_type === this.selectedSectionId)
    },

    showFixedPriceSection() {
      return this.isSection(FIXED_PRICE_TYPE) && this.selectedFares.length
    },

    showOriginDestinationSection() {
      return this.isSection(ORIGIN_DESTINATION_TYPE) && (
        this.selectedFares.length || this.wstrackEnabled
      )
    },

    showDownloadableSection() {
      return this.isSection(DOWNLOADABLE_TYPE)
    }
  },

  watch: {
    visibleSections(newVisibleSections) {
      if (!this.selectedSectionId && newVisibleSections.length) {
        this.selectedSectionId = newVisibleSections[0].value
      }
    }
  },

  async created() {
    await this.getPrePurchaseFares()
    await this.getWstrackEnabled()
  },

  methods: {
    async getPrePurchaseFares() {
      const params = {municipality_id: this.$municipality.id, per: '0', template: 'basic_v2'}
      const {data} = await PrePurchaseFaresService.index(params)
      this.fares = data
    },

    async getWstrackEnabled() {
      const params = {municipality_id: this.$municipality.id}
      const {data} = await WstrackAmiService.enabled(params)
      this.wstrackEnabled = data
    },

    isSection(sectionId) {
      return this.selectedSectionId === sectionId
    },

    step(index) {
      this.selectedSectionId = this.visibleSections[index].value  
    },

    getIcon(type) {
      return ICON_CLASSES[type]
    },

    filteredFares(type) {
      return this.fares.filter(fare => fare.origin_destination_type === type)
    },

    applyContrasteCss(){
      // console.log(`applying high contrast for component ${this.$options.name} (${this.contraste})`)

      if(this.contraste){
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop ,.flex-middle,.ns-layout__footer__footer").css("cssText" ," color: #ffffff !important")
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop").css("background-color" ,"#1e1e1e")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 , .ns-layout__sidebar__map__menu").css("cssText" ," color: #ffffff !important")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 ").css("background-color" ,"#1e1e1e")
        $("a ,.sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items , .pb-d6 , .sidepanel-map__card--item__point-name").css("color" ,"#fff")
        $(".sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items ,.pb-d6, .sidepanel-map__card--item__point-name,.flex-middle ,.sidepanel-map__header").css( "cssText" ,"background-color: #1e1e1e !important")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("color" ,"#fff")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("background-color" ,"#1e1e1e")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title ").css("color" ,"#fff")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title,.colorFondo ").css("background-color" ,"#1e1e1e")
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube").css("color" ,"#1e1e1e");
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube").css("background-color" ,"#fff")
        $(" .pb-d6 ").css("color" ,"#fff")  
        $("#iconorestablecer").css("color" ,"#1e1e1e");
        $("#iconorestablecer").css("background-color" ,"#fff")
        $("#textorestablecer").css("color" ,"#1e1e1e");
        $("#textorestablecer").css("background-color" ,"#fff")
        $(".text-gray2,.text-primary-hover ,.ns-layout__footer, .ns-layout__footer__footer,.hidden-cl ").css("cssText" ," color: #ffffff !important")
        $(".panel-schedules ,.px-d2 , .ns-session__nav--login ,.ns-layout__footer__footer").css( "cssText" ,"background-color: #1e1e1e !important")
        $(".ns-tabs ").css("background-color" ,"#1e1e1e")
        $("#linkhome ").css( "cssText" ,"color: #1e1e1e !important")
      
        $(".tablacss ").css( "cssText" ,"color: #1e1e1e !important")
        $(".tablacss ").css("background-color" ,"#fff")
        $(".ns-icon-angle-left,.sidepanel-map__card--item__stop ").css("color" ,"#fff")
        $(".ns-icon-angle-left ").css("background-color" ,"#1e1e1e")
        $("#linkhome ").css( "cssText" ,"color: #1e1e1e !important")
        $(".ns-layout__sidebar__map__menu").css("background-color" ,"#ffffff")
        $(".textomenu ").css( "cssText" ,"color: #1e1e1e !important")
        $("#linkhome ").css( "cssText" ,"color: #1e1e1e !important")
        $(".ns-layout__sidebar__map__menu").css("background-color" ,"#ffffff")
        $(".textomenu ").css( "cssText" ,"color: #1e1e1e !important")

        $(".submenuusuario").css("background-color" ,"#ffffff")
        $(".submenuusuario").css( "cssText" ,"color: #1e1e1e !important")
        $("#tarifas ").css("background-color" ,"#1e1e1e")

        $(".button-phone").css("border", "2px solid #ffffff")
        $(".option-menu").css("border", "none")
        $( ".active" ).css("background-color","transparent").css("border","2px solid #1e1e1e");
      }else{
        
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop").css("color" ,"")
        $(".ns-layout ,.ns-layout__header, .text-black , .text-gray2 , .sidepanel-map__card--item__stop--route , .sidepanel-map__card--item__stop").css("background-color" ,"")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 , .ns-layout__sidebar__map__menu").css("color" ,"")
        $(".text-primary , .text-gray2-hover , .button-phone , .text-gray3 , .ns-layout__sidebar__map__menu").css("background-color" ,"")
        $("a ,.sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items , .pb-d6 , .sidepanel-map__card--item__point-name").css("color" ,"")
        $(".sidepanel-map__container, .recharge-home__recharges , .recharge-home__cities , .ns-layout__footer__items ,.pb-d6, .sidepanel-map__card--item__point-name,.flex-middle ,.sidepanel-map__header").css( "background-color" ,"")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("color" ,"")
        $(".sidepanel-map--planner__form , .uppercase-vz ,.hidden-xs ,.panel,.ns-field__label,.uppercase ,#fares-side-menu,.flex-column").css("background-color" ,"")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title ").css("color" ,"")
        $("label,.ns-tabs__item,.primay-dark,.text-small, .ns-icon-angle-right ,.h1-main-title,.text-main-title,.ns-session__nav--login ").css("background-color" ,"")
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube,.ns-tabs, .button-tabs,.text-primary-hover,.ns-layout__footer__footer,.hidden-cl").css("color" ,"");
        $(".ns-layout__header--city , .ns-button,.text-info , .ns-icon-youtube ,.mb-d1-2 ,.px-d2 ,.ns-tabs__item ,.panel-schedules ,.ns-tabs, .button-tabs,.ns-layout__footer__footer,.hidden-cl").css("background-color" ,"")
        $(" .pb-d6 ,.panel-schedules ,.px-d2 ").css("color" ,"")  
        $("#iconorestablecer").css("color" ,"#1e1e1e");
        $("#iconorestablecer").css("background-color" ,"#fff")
        $("#textorestablecer").css("color" ,"#1e1e1e");
        $("#textorestablecer").css("background-color" ,"#fff")
        $("#linkhome").css( "color" ,"")
        $(".textomenu").css( "color","")
        $(".tablacss ").css( "color","")
        $(".tablacss ").css("background-color" ,"")
        $(".ns-icon-angle-left ").css("color" ,"")
        $(".ns-icon-angle-left ,.colorFondo  ").css("background-color" ,"")
      }

    }
  }
})